import React, { FC, useEffect, useState, Dispatch, SetStateAction, useContext } from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { LogD } from '../../../function/LogLapper';
import { Grid } from '@material-ui/core';
import SelectSettings, { MenuContents } from '../../organisms/SelectSettings';
import CollectSetting from './CollectSetting/CollectSetting';
import DeviceRegist from './DeviceRegist/DeviceRegist';
import ItemRegist from './ItemRegist';
import AlmKindRegistPage from './AlmKindRegist/AlmKindRegistPage';
import IoTBoxSettingPage from './IoTBoxSetting/IoTBoxSettingPage';
import EMCSettingPage from './EMCSetting/EMCSettingPage';
import StudySettingPage from './StudySetting/StudySettingPage';
import ConanairManagementPage from './ConanairManagement/ConanairManagementPage';
import PartialDischargeCollectionPage from './PartialDischargeCollection/PartialDischargeCollectionPage';

import { useTranslation } from 'react-i18next';
import { AppContext } from '../../../App';

type MeasureSettingsProps = {};

const useStyles = makeStyles(
  createStyles({
    tableContainer: {
      maxHeight: 'calc(100vh - 300px)',
    },
  })
);

const MeasureSettingsPage: React.FC<MeasureSettingsProps> = (props: MeasureSettingsProps) => {
  const { t } = useTranslation();
  const classes = useStyles();
  console.log('== MeasureSettings ==');
  const { login } = useContext(AppContext);

  //コナンエア画面有効フラグ
  const conanairEnabled: boolean = login.GetSystemSettingModel.ConanairEnabled === 1 ? true : false;
  //Emcb画面有効フラグ
  const emcbEnabled: boolean = login.GetSystemSettingModel.EmcbEnabled === 1 ? true : false;
  //部分放電画面有効フラグ
  const partialDischargeEnabled: boolean = login.GetSystemSettingModel.PartialDischargeEnabled === 1 ? true : false;

  const menuList: MenuContents[] = [];

  menuList.push({
    name: t('MeasureSettingsPage.データ収集設定', 'データ収集設定'),
    component: CollectSetting,
    tag: 'Collect',
  });
  menuList.push({
    name: t('MeasureSettingsPage.異常種別登録', '異常種別登録'),
    component: AlmKindRegistPage,
    tag: 'AlarmKind',
  });
  menuList.push({
    name: t('MeasureSettingsPage.機器番号_名称登録', '機器番号・名称登録'),
    component: DeviceRegist,
    tag: 'Device',
  });
  menuList.push({ name: t('MeasureSettingsPage.項目名称登録', '項目名称登録'), component: ItemRegist, tag: 'Item' });
  if (emcbEnabled) {
    menuList.push({
      name: t('MeasureSettingsPage.EMCBPRO収集設定', 'EMCB-Pro-収集設定'),
      component: EMCSettingPage,
      tag: 'EMC',
    });
  }
  menuList.push({
    name: t('MeasureSettingsPage.学習設定', '学習設定'),
    component: StudySettingPage,
    tag: 'StudySetting',
  });
  if (conanairEnabled) {
    menuList.push({
      name: t('MeasureSettingsPage.コナンエアー管理画面', 'コナンエアー管理画面'),
      component: ConanairManagementPage,
      tag: 'ConanairManagement',
    });
  }
  if (partialDischargeEnabled) {
    menuList.push({
      name: t('MeasureSettingsPage.部分放電収集設定', '部分放電収集設定'),
      component: PartialDischargeCollectionPage,
      tag: 'PartialDischargeCollection',
    });
  }

  if (login.IsIoT) {
    // IoTの時は先頭に管理画面を追加
    menuList.splice(0, 0, {
      name: t('MeasureSettingsPage.IoTBox管理画面', 'IoTBox管理画面'),
      component: IoTBoxSettingPage,
      tag: 'IoT',
    });
    //console.debug(['★★★', index, menuList]);
  }

  return (
    <Grid container justify="flex-start" spacing={1} direction="row" alignItems="center" style={{ marginRight: 0 }}>
      <SelectSettings menuList={menuList} />
    </Grid>
  );
};

export default MeasureSettingsPage;
